import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import FollowupsScheduleList from "./followups-schedule";
import { Badge } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { API_URL } from "src/utilities";
import { useAuth } from "src/context/auth";
import { IFollowupSchedule } from "src/interface/IFollowupSchedule";
import PageTitle from "../../components/PageTitle";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function TabTypeSchedule() {
  const { user } = useAuth();

  const { isLoading, error, data, refetch } = useQuery<IFollowupSchedule[]>({
    queryKey: ["FollowupsScheduleData"],
    queryFn: () =>
      fetch(API_URL + "followup-schedule", {
        method: "GET",
        headers: {
          Authorization: `Bearer ${user?.token}`,
          Aceept: "application/json",
        },
      }).then((res) => res.json()),
  });
  const [rows, setRows] = React.useState<IFollowupSchedule[]>([]);
  React.useEffect(() => {
    //@ts-ignore
    data && setRows(data.data?.filter((r) => r.parentRef === null));
  }, [data, user?.token]);

  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <>
      <PageTitle title="پیگیری‌های دوره‌ای" />
      <Box>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab
              label={
                <Badge
                  badgeContent={
                    rows.filter((r) => r.agreementRef === null).length
                  }
                  color="primary"
                >
                  داخلی
                </Badge>
              }
              {...a11yProps(0)}
            />

            <Tab
              label={
                <Badge
                  badgeContent={
                    rows.filter((r) => r.agreementRef !== null).length
                  }
                  color="primary"
                >
                  مشتریان
                </Badge>
              }
              {...a11yProps(1)}
            />
          </Tabs>
        </Box>

        <CustomTabPanel value={value} index={0}>
          <FollowupsScheduleList
            followupType="Customer"
            key={"Customer"}
            error={error}
            isLoading={isLoading}
            refetch={refetch}
            rows={rows}
            setRows={setRows}
          />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <FollowupsScheduleList
            followupType="Agreement"
            key={"Agreement"}
            error={error}
            isLoading={isLoading}
            refetch={refetch}
            rows={rows}
            setRows={setRows}
          />
        </CustomTabPanel>
      </Box>
    </>
  );
}
